"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var helpers_1 = require("helpers");
var ProductCard = /** @class */ (function (_super) {
    __extends(ProductCard, _super);
    function ProductCard(props) {
        var _this = _super.call(this, props) || this;
        _this.collectionProduct = React.createRef();
        _this.handleScroll = function () {
            var impression = _this.buildProductSeo();
            impression.list = _this.props.listing ? _this.props.listing : _this.props.product.url;
            helpers_1.inViewport(_this.collectionProduct.current, 50) && !_this.state.tracked
                ? (helpers_1.trackImpression(window.dataLayer, impression, _this.context.state.shop
                    ? _this.context.state.shop.currency
                    : _this.props.data && _this.props.data.cart
                        ? _this.props.data.cart.currency.iso_code
                        : "AUD", _this.context.state.collection ? _this.context.state.collection.title : "Search"),
                    _this.setState({
                        tracked: true,
                    }))
                : null;
        };
        _this.handleClick = function () {
            var product = _this.buildProductSeo();
            helpers_1.trackProductClick(window.dataLayer, product, _this.context.state.shop
                ? _this.context.state.shop.currency
                : _this.props.data && _this.props.data.cart
                    ? _this.props.data.cart.currency.iso_code
                    : "AUD", window.location.pathname);
        };
        _this.handleAddToCart = function (variant) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, next_components_1.ShopifyNext.Cart.addItem(parseInt(variant, 10), 1)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getPreorderStatus = function (result) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if ((_c = (_b = (_a = result) === null || _a === void 0 ? void 0 : _a.metafields) === null || _b === void 0 ? void 0 : _b.preorderme) === null || _c === void 0 ? void 0 : _c.value) {
                var mfield = JSON.parse((_f = (_e = (_d = result) === null || _d === void 0 ? void 0 : _d.metafields) === null || _e === void 0 ? void 0 : _e.preorderme) === null || _f === void 0 ? void 0 : _f.value);
                var firstVariant = (_j = (_h = (_g = result) === null || _g === void 0 ? void 0 : _g.variants) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.id;
                if (mfield && mfield[firstVariant] && mfield[firstVariant].enabled) {
                    return true;
                }
            }
            return false;
        };
        _this.state = {
            hover: false,
            tracked: false,
        };
        _this.timer = null;
        return _this;
    }
    ProductCard.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.handleScroll, false);
        this.handleScroll();
    };
    ProductCard.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.handleScroll, false);
        clearTimeout(this.timer);
    };
    ProductCard.prototype.handleHover = function (status) {
        var _this = this;
        var time = 300;
        this.timer && clearTimeout(this.timer);
        var timer = setTimeout(function () {
            _this.setState({
                hover: status,
            });
        }, time);
        this.timer = timer;
    };
    ProductCard.prototype.buildProductSeo = function () {
        var product = this.props.product;
        var variant = product.variants && product.variants.length ? product.variants[0] : null;
        var title = product.name ? product.name : product.title;
        var sku = product.sku ? product.sku : variant.sku;
        var tags = product.tags_array ? product.tags_array : product.tags;
        var sale = variant.compare_at_price > variant.price ? "Sale" : "";
        var inventory = product.ss_inventory_count != null ? product.ss_inventory_count : product.variants[0].inventory_quantity;
        var seoProduct = {
            name: title,
            id: sku,
            brand: product.vendor,
            category: product.product_type,
            // list: this.props.listing ? this.props.listing : product.url,
            position: this.props.seoPosition ? this.props.seoPosition : 1,
            price: (product.variant_price ? product.variant_price : product.price) / 100,
            //   variant: colour,
            dimension11: variant.title,
            dimension12: parseInt(inventory, 10) > 0,
            dimension13: sale,
        };
        return seoProduct;
    };
    ProductCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, product = _a.product, className = _a.className, ratio = _a.ratio, reduced = _a.reduced, simple = _a.simple, firstImageIndex = _a.firstImageIndex, small = _a.small, quickAdd = _a.quickAdd;
        var imageIndex = firstImageIndex || 0;
        var hoverIndex = imageIndex !== 0 ? 0 : 1;
        var sizeIndex = product
            && product.options_with_values
            && product.options_with_values.find(function (option) { return option.name && option.name.toLowerCase() == "size"; })
            ? product.options_with_values.find(function (option) { return option.name && option.name.toLowerCase() == "size"; }).position
            : null;
        var sizes = product
            && product.options_with_values
            && product.options_with_values.filter(function (option) { return option.name && option.name.toLowerCase() == "size"; }).length > 0
            ? product.options_with_values
                .filter(function (option) { return option.name && option.name.toLowerCase() == "size"; })[0]
                .values.filter(function (value) { return value !== "-"; })
                .filter(function (value) { return value !== "."; })
            : [];
        var tags = product.tags_array ? product.tags_array : product.tags || [];
        var hasVariants = product.variants && product.variants.length > 1;
        var colors = tags && tags.length && tags.filter(function (tag) { return tag.includes("colour:"); }) ? tags.filter(function (tag) { return tag.includes("colour:"); }) : [];
        // const color =
        //   product &&
        //     product.options_with_values &&
        //     product.options_with_values.length &&
        //     product.options_with_values.filter((option) => option.name && option.name.toLowerCase() == "color").length > 0
        //     ? product.options_with_values
        //       .filter((option) => option.name && option.name.toLowerCase() == "color")[0]
        //       .values.filter((value) => value !== "-").filter((value) => value !== '.')
        //     : [];
        // colors.push(color);
        var offerText = tags.filter(function (tag) { return tag.includes("offertext:"); }).length > 0
            ? tags.filter(function (tag) { return tag.includes("offertext:"); }).map(function (tag) { return tag.replace("offertext:", ""); })
            : [];
        var label = tags.filter(function (tag) { return tag.includes("label:"); }).length > 0
            ? tags.filter(function (tag) { return tag.includes("label:"); }).map(function (tag) { return tag.replace("label:", ""); })
            : [];
        var variant = product.variants && product.variants.find(function (v) { return v.available; })
            ? product.variants.find(function (v) { return v.available; })
            : product.variants
                ? product.variants[0]
                : null;
        var price = product.price ? product.price : variant && variant.price ? variant.price : 0;
        var compare_at_price = product.compare_at_price
            ? product.compare_at_price
            : product.compare_at_price_min
                ? product.compare_at_price_min
                : variant && variant.compare_at_price
                    ? variant.compare_at_price
                    : 0;
        // compare_at_price > price ? label.push("Sale") : null;
        var url = this.context.state.collection
            ? this.context.state.collection.url + "/products/" + product.handle
            : "/products/" + product.handle;
        var image = product.images && product.images[imageIndex] && product.images[imageIndex].sizes && product.images[imageIndex].sizes[640]
            ? product.images[imageIndex].sizes[640]
            : product.images && product.images[imageIndex] && product.images[imageIndex].src
                ? product.images[imageIndex].src
                : product.images && product.images[imageIndex] && product.images[imageIndex]
                    ? product.images[imageIndex]
                    : null;
        var hoverimage = product.images
            && product.images.length > 1
            && product.images[hoverIndex]
            && product.images[hoverIndex].sizes
            && product.images[hoverIndex].sizes[640]
            ? product.images[hoverIndex].sizes[640]
            : product.images && product.images[hoverIndex] && product.images[hoverIndex].src
                ? product.images[hoverIndex].src
                : product.images && product.images[hoverIndex] && product.images[hoverIndex]
                    ? product.images[hoverIndex]
                    : null;
        var preorder = this.getPreorderStatus(product);
        var customer = this.props.customer
            ? this.props.customer
            : this.props.data && this.props.data.customer
                ? this.props.data.customer
                : {};
        return (React.createElement("div", { ref: this.collectionProduct, className: "block relative mb-0-8 h-100 " + (simple ? "md:mb-2-4" : "" + (this.state.hover ? "md:mb-1-6 md:-mt-0-6" : "md:mb-2-4")) + " " + (className ? " " + className : ""), onClick: function () { return _this.handleClick(); } },
            React.createElement("div", { onMouseEnter: function () { return _this.handleHover(true); }, onMouseLeave: function () { return _this.handleHover(false); }, className: "mx-0-8 -ml-0-2 h-full " + (quickAdd ? "min-h-40" : "min-h-33-6") + " " + (simple
                    ? "" + (small ? (quickAdd ? "md:min-h-40" : "md:min-h-33-6") + " md:mx-0-4" : "md:min-h-42 md:mx-0-8 ")
                    : "" + (this.state.hover ? "shadow-active md:mx-0-6  md:min-h-42" : "shadow-block md:mx-1-2  md:min-h-42")) + " bg-arctic relative transition-fast flex flex-col" },
                preorder ? (React.createElement("div", { className: "absolute pin-l pin-t bg-white" },
                    React.createElement("span", { className: "font-sans font-normal text-sm text-midnight block p-1 capitalize" }, "Pre-Order"))) : null,
                React.createElement(Snippets.BlockImage, { image: image, hoverImage: hoverimage, ratio: "" + (ratio || "1:1"), className: "" + (reduced ? "mb-1" : ""), hover: this.state.hover, sizes: sizes, sizeIndex: sizeIndex, variants: product.variants, href: url, title: product.title, label: label }),
                React.createElement("div", { className: "px-1-6 pt-1-2 pb-1-9 md:pb-1-6 block no-underline group flex flex-col flex-1", draggable: false },
                    React.createElement(Snippets.ProductFlags, { items: offerText, className: "ie-product-flags font-semibold mb-0-2", size: "text-xs" }),
                    React.createElement("div", { className: "flex flex-col items-between flex-1" },
                        React.createElement("a", { className: "flex flex-col text-midnight mb-0-2 md:mb-0-8 flex-1 md:pr-2", href: url, title: product.title }, product.title ? (React.createElement("h4", { className: "font-semibold text-sm md:text-base tracking-normal leading-1.29 " }, product.title)) : null),
                        this.context.state.shop ? (React.createElement("div", { className: "md:text-right md:mt-0 flex items-center justify-between text-midnight" },
                            React.createElement(Snippets.ProductPrice, { variant: variant, collectionThumb: this.props.collectionThumb, layout: "collection", showDiscount: false, showWasNow: false, showCurrency: false, moneyFormat: this.context.state.shop.money_format, moneyFormatCurrency: this.context.state.shop.money_with_currency_format, inline: true }),
                            React.createElement(Snippets.WishlistCardIcon, { className: "w-2-0 h-2-0 min-w-2-0 flex items-center justify-center text-black", customer: customer, product: product, variant: variant }))) : null)),
                this.props.quickAdd ? (React.createElement("div", { className: "w-full px-1-6" },
                    React.createElement("button", { className: "flex justify-center items-center text-xs h-4 w-full mt-0-8 mb-1-6 bg-accent-primary text-arctic font-bold rounded", onClick: function () { return _this.handleAddToCart(variant.id); }, disabled: variant.inventory_quantity <= 0 && variant.inventory_policy === "deny" }, "Add to Cart"))) : null,
                !simple ? (sizes && sizes.length > 0 ? (React.createElement("div", { className: "hidden md:block absolute z-10 w-full " + (this.state.hover ? "visible shadow-bottom" : "invisible") + " text-primary text-xs text-center transition-fast", style: { top: "100%" } },
                    React.createElement("div", { className: "relative  bg-grey-light w-full" },
                        React.createElement("div", { className: "pin absolute bg-light opacity-75" }),
                        React.createElement("div", { className: "relative p-1-6 text-xs " },
                            React.createElement("div", { className: "text-left mb-0-8" }, "Select size to add to cart"),
                            React.createElement("div", { className: "flex flex-wrap items-center justify-center text-center uppercase font-bold -mx-0-4" }, sizes.map(function (size, index) {
                                var applicableVariants = sizeIndex && product.variants && product.variants.filter(function (variant) { return variant["option" + sizeIndex] == size; });
                                var attachedVariant = applicableVariants && applicableVariants.length ? applicableVariants[0] : null;
                                return attachedVariant ? (React.createElement("button", { key: index, title: product.title + " in " + size, onClick: function () { return _this.handleAddToCart(attachedVariant.id); }, className: "flex items-center justify-center relative overflow-hidden w-3-8 h-2-8 " + (attachedVariant.inventory_quantity > 0
                                        ? "bg-arctic text-midnight border border-arctic shadow-inactive hover:bg-grey"
                                        : "bg-grey-light text-secondary-blue-grey border-grey-border") + " uppercase font-medium mx-0-4 mb-0-4 flex justify-center items-center border rounded no-underline", disabled: attachedVariant.inventory_quantity < 1 }, size)) : (React.createElement("div", { key: index, title: product.title + " in " + size, className: "w-8 h-8 bg-light text-primary uppercase font-medium mx-0-4 mb-0-4 flex justify-center items-center border border-grey rounded-full no-underline" }, size));
                            })))))) : (React.createElement("div", { className: "hidden md:block absolute z-10 w-full " + (this.state.hover ? "visible shadow-bottom" : "invisible") + " text-primary text-xs text-center transition-fast", style: { top: "100%" } },
                    React.createElement("div", { className: "relative  bg-grey-light w-full" },
                        React.createElement("div", { className: "pin absolute bg-light opacity-75" }),
                        React.createElement("div", { className: "relative p-1-6 text-xs text-midnight" }, hasVariants ? (React.createElement("a", { className: "flex justify-center items-center text-xs h-4 w-full mt-0-8 mb-1-6 bg-accent-primary text-arctic font-bold rounded", href: url }, "Select size")) : (React.createElement("button", { className: "flex justify-center items-center text-xs h-4 w-full mt-0-8 mb-1-6 bg-accent-primary text-arctic font-bold rounded", onClick: function () { return _this.handleAddToCart(variant.id); }, disabled: variant.inventory_quantity <= 0 && variant.inventory_policy === "deny" }, "Add to cart"))))))) : null)));
    };
    ProductCard.contextType = next_components_1.ShopifyNext.Context;
    return ProductCard;
}(React.PureComponent));
exports.ProductCard = ProductCard;
